import r from "./partial.js";
import o from "./before.js";
var a = r(o, 2);
export { a as default };